// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#editor-container {\n\theight: calc(100% - 50px);\n\ttop: 50px;\n}\n", ""]);
// Exports
module.exports = exports;
